/*
  Carrito de Amada Barcelona — cuenta atrás y carrusel de upsell.

  POR QUÉ ESTE FICHERO EXISTE
  Este JS vivía dentro de los snippets del carrito. Como esos snippets se
  vuelven a insertar en CADA actualización del carrito, cada añadido creaba un
  temporizador nuevo y dejaba el anterior corriendo. Medido el 8-9-2026: cuatro
  añadidos, cuatro temporizadores vivos. Cada uno escribía en el DOM cada
  segundo, el observador reaccionaba a esa escritura y arrancaba otro. El móvil
  acababa sin responder al tacto y había que refrescar.

  Reglas de este fichero:
   · Se carga UNA vez desde la sección, fuera de lo que se repinta.
   · UN solo temporizador para toda la vida de la página.
   · CERO MutationObserver. Los clics van por delegación sobre el cajón, así
     que da igual cuántas veces se repinte por dentro.
*/
(function () {
  if (window.__amadaCarrito) return;
  window.__amadaCarrito = true;

  /*
    Marca de que el contador está vivo. El CSS solo esconde el valor de
    plantilla si esta clase está puesta: si el fichero no llegara a cargar, el
    09:59 se ve igual y la frase no queda coja.
  */
  document.documentElement.classList.add('amada-temporizador');

  var SEGUNDOS = 599;               // announcementTimer de Upcart
  var CLAVE = 'amada_carrito_fin';

  /*
    La cuenta atrás arranca en el PRIMER añadido y sigue corriendo: no se
    reinicia al añadir otro producto ni al cambiar de página. Por eso el
    vencimiento se guarda como marca de tiempo en localStorage y no como un
    contador en memoria, que moría con cada carga.

    Se borra cuando el carrito se queda vacío, para que el siguiente primer
    añadido vuelva a empezar de cero.
  */
  function leeFin() {
    try {
      var v = parseInt(localStorage.getItem(CLAVE), 10);
      return isNaN(v) ? null : v;
    } catch (e) { return null; }    // navegación privada, cookies bloqueadas
  }
  function guardaFin(t) { try { localStorage.setItem(CLAVE, String(t)); } catch (e) {} }
  function borraFin() { try { localStorage.removeItem(CLAVE); } catch (e) {} }

  var enMemoria = null;             // respaldo si localStorage no está disponible

  function pinta() {
    var cajon = document.getElementById('cart-drawer');
    if (cajon && cajon.classList.contains('is-empty')) {
      borraFin();
      enMemoria = null;
      return;
    }

    // Acotado al cajón a propósito: /cart renderiza su propio aviso —escondido—
    // y sin esto se pintaba ese y nunca el del cajón.
    var nodo = document.querySelector('#cart-drawer [data-cart-timer]');
    if (!nodo) return;              // sin línea en el carrito no hay nada que pintar

    var ahora = Date.now();
    var fin = leeFin();
    if (fin === null) fin = enMemoria;
    if (fin === null || fin <= ahora) {
      fin = ahora + SEGUNDOS * 1000;
      guardaFin(fin);
      enMemoria = fin;
    }

    var quedan = Math.round((fin - ahora) / 1000);
    if (quedan < 0) quedan = 0;
    var m = Math.floor(quedan / 60), s = quedan % 60;
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    if (nodo.textContent !== txt) nodo.textContent = txt;
    if (!nodo.hasAttribute('data-listo')) nodo.setAttribute('data-listo', '');
  }

  /*
    Cada vez que el carrito se repinta, el snippet vuelve a escribir el 09:59
    de plantilla, y con un tic de un segundo eso se veía como un parpadeo de
    reinicio. El nodo recién insertado nace invisible —lo esconde el CSS
    mientras no tenga data-listo— y se refresca diez veces por segundo, que es
    un querySelector y una comparación de texto: nada.
  */
  setInterval(pinta, 100);
  ['theme:cart:change', 'theme:cart:update', 'theme:cart:refresh', 'theme:cart:add'].forEach(function (ev) {
    document.addEventListener(ev, function () { pinta(); setTimeout(pinta, 120); });
  });
  pinta();

  /*
    ── ATRIBUCIÓN DEL UPSELL ───────────────────────────────────────────────

    POR QUÉ EXISTE. Al añadir desde el cajón, el pedido llega a Shopify
    idéntico a si se hubiera añadido desde la ficha: no queda ni rastro de que
    vino del carrusel. Upcart calculaba ese porcentaje en SUS servidores y se
    fue con ella (9-9). Sin esto, con tráfico en marcha, no se puede decidir si
    el upsell aporta o estorba — que es justo lo que hay que decidir.

    🔴 ATRIBUTO DE CARRITO, NO PROPIEDAD DE LÍNEA. Una propiedad de línea
    PARTE EN DOS la misma variante: si la clienta ya tenía ese producto en el
    carrito desde la ficha, le aparecerían dos renglones del mismo artículo. El
    atributo es metadato del carrito entero, invisible para ella, y no toca las
    líneas.

    🔴 Y NO HACE FALTA DESCONTAR AL QUITAR. Si añade del upsell y luego lo
    quita, el atributo seguiría diciendo que lo añadió — pero esa línea ya no
    está en el pedido, así que al cruzar los dos al leerlo (mín. entre lo
    anotado y lo que de verdad se compró) el resultado es cero. El atributo es
    un TECHO, no una cuenta; el pedido manda. Eso ahorra tener que tocar los
    manejadores de quitar y de cambiar cantidad, que es donde se rompen estas
    cosas.

    Formato: "idVariante:unidades,idVariante:unidades". Feo de leer para una
    persona y trivial de interpretar para el libro de ventas, que es quien lo
    va a leer.
  */
  var ATRIBUTO = 'upsell';

  function anotarUpsell(variante) {
    // Se lee lo que ya hay: se puede añadir más de una cosa del carrusel, y
    // escribir a pelo borraría lo anterior.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carro) {
        var previo = (carro && carro.attributes && carro.attributes[ATRIBUTO]) || '';
        var cuenta = {};
        previo.split(',').forEach(function (par) {
          var t = par.split(':');
          var id = parseInt(t[0], 10);
          var n = parseInt(t[1], 10);
          if (id && n) cuenta[id] = (cuenta[id] || 0) + n;
        });
        cuenta[variante] = (cuenta[variante] || 0) + 1;
        var valor = Object.keys(cuenta).map(function (id) {
          return id + ':' + cuenta[id];
        }).join(',');
        var attrs = {};
        attrs[ATRIBUTO] = valor;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () {});   // Nunca rompe el añadido.
  }

  // ── Carrusel y añadir, por delegación ──────────────────────────────────
  document.addEventListener('click', function (e) {
    var prev = e.target.closest && e.target.closest('[data-cart-upsell-prev]');
    var next = e.target.closest && e.target.closest('[data-cart-upsell-next]');
    var add = e.target.closest && e.target.closest('[data-upsell-add]');

    if (prev || next) {
      var caja = (prev || next).closest('[data-cart-upsell]');
      var pista = caja && caja.querySelector('[data-cart-upsell-track]');
      if (!pista) return;
      var t = caja.querySelector('.cart-upsell__slide');
      var paso = t ? t.getBoundingClientRect().width + 12 : pista.clientWidth;
      pista.scrollBy({ left: (next ? 1 : -1) * paso, behavior: 'smooth' });
      return;
    }

    if (add) {
      if (add.dataset.ocupado) return;
      var tarjeta = add.closest('[data-upsell-card]');
      var sel = tarjeta && tarjeta.querySelector('[data-upsell-variante]');
      if (!sel || !sel.value) return;
      add.dataset.ocupado = '1';
      var variante = Number(sel.value);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variante, quantity: 1 }] })
      }).then(function () {
        // Se anota DESPUÉS de que el añadido haya ido bien, y sin encadenar:
        // si la anotación fallara, la clienta ya tiene su producto y eso es lo
        // que importa. El dato se pierde; la venta no.
        anotarUpsell(variante);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }).catch(function () {}).then(function () {
        delete add.dataset.ocupado;
      });
    }
  }, false);

  // Precio de la tarjeta al cambiar de variante, también por delegación.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('select[data-upsell-variante]')) return;
    var tarjeta = sel.closest('[data-upsell-card]');
    if (!tarjeta) return;
    var o = sel.options[sel.selectedIndex];
    var ins = tarjeta.querySelector('[data-upsell-precio]');
    var del = tarjeta.querySelector('[data-upsell-comparado]');
    if (ins && o.dataset.precio) ins.textContent = o.dataset.precio;
    if (del && o.dataset.comparado) del.textContent = o.dataset.comparado;
  }, false);

  // ── Cantidades y quitar, SIEMPRE por clave de línea ─────────────────────
  /*
    El tema manda /cart/change con {line: N}, un ÍNDICE. Y Shopify coloca cada
    producto recién añadido EL PRIMERO, así que al añadir algo todos los índices
    de las demás líneas se desplazan. Si el HTML del cajón va un paso por detrás
    —basta con que una actualización no repinte a tiempo—, el «−» de una línea
    acaba modificando otra: es lo que le pasó a David el 8-9-2026, sumando
    cantidad en la línea de arriba al pulsar el menos de la del medio.

    La clave de línea (data-id) es única y no se mueve nunca. Se intercepta el
    clic en captura, se resuelve por clave y se corta el manejador del tema.
  */
  function claveDeLinea(el) {
    var linea = el.closest && el.closest('.cart__item');
    if (!linea) return null;
    var campo = linea.querySelector('.cart__quantity-field');
    return campo && campo.dataset.id ? campo.dataset.id : null;
  }

  function cambia(clave, cantidad) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad })
    }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var menos = t.closest('.cart__quantity-minus');
    var mas = t.closest('.cart__quantity-plus');
    var quitar = t.closest('.cart__item__remove');
    if (!menos && !mas && !quitar) return;
    if (!t.closest('#cart-drawer')) return;      // solo el cajón

    var clave = claveDeLinea(t);
    if (!clave) return;                          // sin clave, que actúe el tema

    e.preventDefault();
    e.stopImmediatePropagation();

    var linea = t.closest('.cart__item');
    var campo = linea.querySelector('.cart__quantity-field');
    var actual = parseInt(campo && campo.value, 10);
    if (isNaN(actual)) actual = 1;

    var nueva = quitar ? 0 : (mas ? actual + 1 : actual - 1);
    if (nueva < 0) nueva = 0;

    if (campo && nueva > 0) campo.value = nueva;  // respuesta inmediata
    cambia(clave, nueva);
  }, true);                                       // captura: antes que el tema
})();